import { Component, OnInit, Input, ViewChild } from "@angular/core";
import {
  ModalController,
  ToastController,
  LoadingController,
  AlertController,
} from "@ionic/angular";
import { AccountService } from "src/app/api/account.service";
import { TransactionsService } from "src/app/api/transactions.service";
import { NewPreviewPage } from "../new-preview/new-preview.page";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";

@Component({
  selector: "app-new-offer",
  templateUrl: "./new-offer.page.html",
  styleUrls: ["./new-offer.page.scss"],
})
export class NewOfferPage implements OnInit {
  @ViewChild("refInput") refInput;

  public newOfferForm: FormGroup;

  public conditions: string[] = ["REF", "NOB", "NEW", "AS IS", "USED"];
  public manufacturerOptions: string[] = ["CISCO", "JUNIPER", "HPE", "DELL", "ARISTA", "IBM", "MELLANOX", "NVIDIA", "BROCADE", "OTHER"];
  public manufacturerList: string[] = ["CISCO", "JUNIPER", "HPE"];
  public manufacturerPriceConstraints: any[] = [];

  @Input() pendingOffers: object[];
  @Input() transactionType: string;
  @Input() transactionMailing: string;

  constructor(
    private modalCtrl: ModalController,
    private accountService: AccountService,
    private transactionsService: TransactionsService,
    private formBuilder: FormBuilder,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController
  ) { }

  ngOnInit() {
    let t = this;
    console.log("INIT");
    this.newOfferForm = this.formBuilder.group({
      reference: [
        null,
        Validators.compose([Validators.required, Validators.maxLength(60)]),
      ],
      quantity: [
        null,
        Validators.compose([
          Validators.required,
          Validators.min(1),
          Validators.max(99999),
        ]),
      ],
      price: [
        null,
        Validators.compose([Validators.min(0), t.customPriceCheck]),
      ],
      condition: [this.conditions[0], null],
      manufacturer: [
        null,
        Validators.compose([Validators.required, Validators.maxLength(20)]
        ),
      ],
      otherManufacturer: [null, Validators.compose([Validators.maxLength(20)])],
      comments: [null, Validators.compose([Validators.maxLength(100)])],
      seller: [{ value: null, disabled: true }, null],
      company: [{ value: null, disabled: true }, null],
    });
    this.transactionsService
      .getConstraints(this.transactionMailing, this.transactionType)
      .then((r) => {
        if (r["results"])
          this.manufacturerPriceConstraints = r["results"].map(
            (o) => o.manufacturer
          );
      })
      .catch(async (e) => {
        let errorMessage = "";
        for (var err in e.error)
          errorMessage += err + " : " + e.error[err].join(".\n");

        let errorToast = await this.toastCtrl.create({
          message: errorMessage,
          showCloseButton: true,
          duration: 3500,
          position: "bottom",
          color: "light",
        });
        errorToast.present();
      });
    let priceControl = t.newOfferForm.get("price");
    if (this.transactionType == "WTS")
      this.newOfferForm.get("manufacturer").valueChanges.subscribe((val) => {
        if (t.manufacturerPriceConstraints.includes(val.toUpperCase())) {
          if (val == "CISCO" || val == "JUNIPER" || val == "HPE") {
            priceControl.setValidators(
              Validators.compose([
                Validators.required,
                Validators.min(0),
                t.customPriceCheck,
              ])
            );
          }
        } else {
          priceControl.setValidators(
            Validators.compose([Validators.min(0), t.customPriceCheck])
          );
          let other_manufacturerValidations = Validators.maxLength(60);

          if (val == "OTHER") {
            other_manufacturerValidations = Validators.compose([
              Validators.required,
              other_manufacturerValidations,
            ]);
          }
          this.newOfferForm
            .get("otherManufacturer")
            .setValidators(other_manufacturerValidations);
        }
        priceControl.updateValueAndValidity();
      });
    this.newOfferForm.get("otherManufacturer").valueChanges.subscribe((val) => {
      if (this.manufacturerList.includes(val)) {
        priceControl.setValidators(
          Validators.compose([
            Validators.required,
            Validators.min(0),
            t.customPriceCheck,
          ])
        );
      }
      if (t.manufacturerPriceConstraints.includes(val.toUpperCase())) {
        priceControl.setValidators(
          Validators.compose([
            Validators.required,
            Validators.min(0),
            t.customPriceCheck,
          ])
        );
      } else {
        priceControl.setValidators(
          Validators.compose([Validators.min(0), t.customPriceCheck])
        );
      }
      priceControl.updateValueAndValidity();
    });
    this.accountService.myProfile().then((response) => {
      let sellerName = "Unknown";

      if (!!response["first_name"] && !!response["last_name"]) {
        sellerName = response["first_name"] + " " + response["last_name"];
      }

      if (!!response["first_name"] && !response["last_name"]) {
        sellerName = response["first_name"];
      }

      if (!response["first_name"] && !!response["last_name"]) {
        sellerName = response["last_name"];
      }

      t.newOfferForm.patchValue({
        seller: sellerName,
        company: response["organization"],
      });
    });

    this.transactionsService
      .getConstraints(this.transactionMailing, this.transactionType)
      .then((r) => {
        if (r["results"])
          this.manufacturerPriceConstraints = r["results"].map(
            (o) => o.manufacturer
          );
      })
      .catch(async (e) => {
        let errorMessage = "";
        for (var err in e.error)
          errorMessage += err + " : " + e.error[err].join(".\n");

        let errorToast = await this.toastCtrl.create({
          message: errorMessage,
          showCloseButton: true,
          duration: 3500,
          position: "bottom",
          color: "light",
        });
        errorToast.present();
      });
  }

  ionViewWillEnter() {
    if (!this.pendingOffers) this.pendingOffers = [];
    setTimeout(() => {
      this.refInput.setFocus();
    }, 150);
  }

  async addOffer() {
    let newOffer = {
      transaction_mailing: this.transactionMailing,
      transaction_type: this.transactionType,
      transaction_reference_typed: this.newOfferForm.value.reference,
      price: !this.newOfferForm.value.price
        ? undefined
        : this.newOfferForm.value.price,
      quantity: this.newOfferForm.value.quantity,
      condition: this.newOfferForm.value.condition,
      manufacturer: !this.newOfferForm.value.manufacturer
        ? undefined
        : this.newOfferForm.value.manufacturer == "OTHER"
          ? this.newOfferForm.value.otherManufacturer
          : this.newOfferForm.value.manufacturer,
      comment: !this.newOfferForm.value.comments
        ? undefined
        : this.newOfferForm.value.comments,
    };

    this.pendingOffers.push(newOffer);

    let toast = await this.toastCtrl.create({
      color: "light",
      message: this.transactionType + " added to the queue",
      duration: 3000,
      showCloseButton: true,
      position: "bottom",
    });

    toast.present();

    await this.modalCtrl.dismiss();

    const modal = await this.modalCtrl.create({
      component: NewOfferPage,
      componentProps: {
        transactionType: this.transactionType,
        transactionMailing: this.transactionMailing,
        pendingOffers: this.pendingOffers,
      },
    });

    return await modal.present();
  }

  async sendOffer() {
    let t = this;

    let newOffer = {
      transaction_mailing: this.transactionMailing,
      transaction_type: this.transactionType,
      transaction_reference_typed: this.newOfferForm.value.reference,
      price: !this.newOfferForm.value.price
        ? undefined
        : this.newOfferForm.value.price,
      quantity: this.newOfferForm.value.quantity,
      condition: this.newOfferForm.value.condition,
      manufacturer: !this.newOfferForm.value.manufacturer
        ? undefined
        : this.newOfferForm.value.manufacturer == "OTHER"
          ? this.newOfferForm.value.otherManufacturer
          : this.newOfferForm.value.manufacturer,
      comment: !this.newOfferForm.value.comments
        ? undefined
        : this.newOfferForm.value.comments,
    };

    this.pendingOffers.push(newOffer);

    let loader = await this.loadingCtrl.create({
      message: "Creating new " + this.transactionType,
    });

    loader.present();

    this.transactionsService
      .create(this.pendingOffers)
      .then(async (response) => {
        t.modalCtrl.dismiss();
        const modal = await t.modalCtrl.create({
          component: NewPreviewPage,
          componentProps: {
            emailInfos: response,
          },
        });

        await modal.present();
      })
      .catch(async (e) => {
        t.pendingOffers.pop();
        let errorMessage = e.error;

        if (e.error["transaction_reference_typed"] != undefined) {
          errorMessage = e.error["transaction_reference_typed"].join(". ");
        }

        let errorToast = await t.toastCtrl.create({
          message: errorMessage,
          showCloseButton: true,
          duration: 3500,
          position: "bottom",
          color: "light",
        });

        errorToast.present();
      })
      .finally(() => {
        loader.dismiss();
      });
  }

  async closeNewOffer() {
    // If no modif, close it without alert
    if (
      !this.newOfferForm.get("reference").value &&
      !this.newOfferForm.get("quantity").value &&
      !this.newOfferForm.get("price").value &&
      !this.newOfferForm.get("manufacturer").value &&
      this.pendingOffers.length == 0
    ) {
      await this.modalCtrl.dismiss(null);
      return;
    }

    let alert = await this.alertCtrl.create({
      header: "Are you sure you want to leave?",
      message: "All pending offers will be lost.",
      buttons: [
        {
          text: "No, take me back",
          role: "cancel",
          cssClass: "cancelAlert",
        },
        {
          text: "Yes, I'm sure",
          cssClass: "validateClose",
          handler: async () => {
            await this.modalCtrl.dismiss(null);
          },
        },
      ],
    });

    await alert.present();
  }

  public customPriceCheck(form: FormControl): { [key: string]: any } {
    let errors = {};
    if (form.value !== null && (form.value + "").length > 11) {
      errors["priceLength"] = (form.value + "").length;
    }

    if (
      form.value !== null &&
      !!form.value.toString().split(/[,.]/)[1] &&
      (form.value.toString().split(/[,.]/)[1] + "").length > 2
    ) {
      errors["decLength"] = form.value.toString().split(/[,.]/)[1].length;
    }

    if (errors !== {}) {
      return errors;
    }

    return null;
  }
}